import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

export const ServiceCard = ({ service, variant = "default" }) => {
  const isLarge = variant === "large";

  return (
    <div
      data-testid={`service-card-${service.id}`}
      className={`service-card bg-white border border-stone-100 hover:border-[#D4AF37]/50 shadow-sm hover:shadow-xl transition-all duration-300 group rounded-2xl relative overflow-hidden ${
        isLarge ? "md:col-span-2 md:row-span-2" : ""
      }`}
    >
      {/* Image */}
      <div className={`relative overflow-hidden ${isLarge ? "h-48 md:h-64" : "h-40"}`}>
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F392B]/60 to-transparent" />
      </div>

      {/* Content */}
      <div className={`p-6 ${isLarge ? "md:p-8" : ""}`}>
        <h3
          className={`font-heading font-semibold text-[#0F392B] mb-2 ${
            isLarge ? "text-2xl md:text-3xl" : "text-xl"
          }`}
        >
          {service.title}
        </h3>
        <p className="font-body text-[#4A5568] text-sm leading-relaxed mb-4">
          {service.shortDesc}
        </p>
        <Link to={`/services#${service.id}`}>
          <Button
            variant="ghost"
            className="p-0 h-auto font-body text-sm font-medium text-[#0F392B] hover:text-[#D4AF37] group/btn"
          >
            Learn More
            <ArrowRight className="w-4 h-4 ml-2 transform group-hover/btn:translate-x-1 transition-transform" />
          </Button>
        </Link>
      </div>

      {/* Decorative corner */}
      <div className="absolute top-4 right-4 w-8 h-8 border-t-2 border-r-2 border-[#D4AF37]/30 rounded-tr-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </div>
  );
};
